import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { themes, SimpleForm, SimpleFormGroup, Dialog } from 'libs/ui';
import { Select2 } from 'libs/form/lib/complex-inputs';
import { getTariffList } from 'services/tariffs-service';

export const TariffSetForm = (props) => {
  const { working, parkingId, tariffId = '' } = props;
  const { t } = useTranslation();
  const [tariff, setTariffState] = useState(tariffId ?? '');
  const [tariffs, setTariffs] = useState([]);

  // get tariffs
  useEffect(() => {
    const flt = { status: 'active' };
    if (window.config.central && parkingId) {
      out.parking_id = parkingId;
    }

    getTariffList(flt, []).then((data) => {
      const items = data.items;
      setTariffs(items);

      if (tariffId && items.length > 0) {
        let selectedTariffId = tariffId;
        const found = data.items.some((el) => el.id === tariffId);
        if (!found) {
          selectedTariffId = data.items[0].id;
        }
        setTariffState(selectedTariffId);
      }
    });
  }, []);

  /**
   * make action
   * @param {*} event
   */
  const action = () => {
    props.action({ tariff_id: tariff });
  };

  /**
   * select change
   * @param {*} event
   */
  const handleTariffChange = (event) => {
    setTariffState(event.target.value);
  };

  if (!tariffs.length) {
    return null;
  }

  const tariffsOk = tariffs.map((el) => ({ value: el.id, name: el.name }));
  const tariffsList = tariffId ? tariffsOk : [{ value: '', name: t('form.Не задано') }, ...tariffsOk];
  const valid = !!tariff;

  return (
    <Dialog
      id="dialog-tariff-set-form"
      title={t('form.Смена тарифа')}
      buttons={[
        { title: t('buttons.Отменить'), onClick: props.close },
        { title: t('buttons.Заменить'), onClick: action, theme: themes.blue, disabled: !valid || working, working },
      ]}
    >
      <SimpleForm>
        <SimpleFormGroup>
          <label htmlFor="set-form-tariff">{t('form.Тариф')}</label>
          <Select2 id="set-form-tariff" onChange={handleTariffChange} value={tariff} items={tariffsList} />
        </SimpleFormGroup>
      </SimpleForm>
    </Dialog>
  );
};

TariffSetForm.propTypes = {
  close: PropTypes.func.isRequired,
  action: PropTypes.func.isRequired,
};
